import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Link } from "react-router-dom";
import { GotoLogin } from "../../actions/renovarLog";
import { useMutation } from "@tanstack/react-query";
// icons
import { Pencil, SquareX, CirclePlus } from "lucide-react";
// style
import style from "../../styles/grid.module.css";

export default function Usuario() {
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "users";
   const [nombre, setName] = useState("");
   
   console.log('url: ', url);
   const { data, isError, isLoading } = useQuery({
      queryKey: ["usuario"],
      queryFn: () => fetch(url,
         {
            headers: {
              "Authorization": `Bearer ${token}`, //mind the space before your token
            }}
      ).then((res) => res.json()),
      // staleTime:30000,  // actualiza la pagina cada 30 segundos solo si salis y volves a entrar o se agrega info
      /*
      actualiza el query cada 4 segundos no importa que 
      refetchInterval: 4000 
      */
   });

   const { mutate } = useMutation({
      mutationFn: (id) =>
         fetch(url + "/" + id, {
            method: "DELETE",
            body: JSON.stringify(),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (res) => {
         if (res?.message){
            alert(`Aviso : ${res.message}`)
        }
         window.location.href = "/usuario";
      },
      onError: () => {
         alert("Error");
      },
   });



   const handleRemove = (id) => {
      let text =
         "Se va a eliminar el Cliente selecionado!\nSelecione Aceptar or Cancelar.";
      if (window.confirm(text) === true) {
         mutate(id);
      }
   };


   // if (data?.message){
   // console.log('data: ', data.message);}
   if (isError) {
      return <div>Error</div>;
   }

   if (isLoading) {
      return <div>Cargando Informacion</div>;
   }
   // const { clientes, q } = useLoaderData();
   // const [nombre, setName] = useState("");
   
   function handleInputChange(e) {
      if (e.key === "Enter") {
         console.log('clientes: ', nombre);
         setName("");
      }
   }
   console.log('data: ', data);
   if (data?.message === "Token inválido") {
      return <GotoLogin />;
   }
   return (
      <div className={style.tableCli}>
         <div>
            <div className={style.header}>
               <div className={style.gridTitle}>
                  <h2>Usuarios</h2>
               </div>
               <div>
                  <Link
                     to={"/formUsuario"}
                     className="dLink"
                     title="Alta Usuario"
                     state={{
                        id: 0,
                        companyId: data[0]?.companyId,
                        nombre: "",
                        email: "",
                        estadoId: 1,
                        id_rank:0,
                        nombrecompleto: "",
                        perfilusuarios:[]
                     }}
                  >
                     {" "}
                     <CirclePlus style={{color: 'white'}}/>
                     {/* <button className={style.inputBtnNew}>Alta Usuario</button> */}
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
         </div>
         <br />
         <div>
            <table className={style.gridTable}>
               <thead>
                  <tr className={style.trBuscar}>
                     <th>Buscar</th>
                     <th className={style.thCli}>
                        <input
                           onKeyPress={(e) => handleInputChange(e)}
                           onChange={(e) => setName(e.target.value)}
                           type="text"
                           id="search-navbar"
                           placeholder="Buscar..."
                           value={nombre}
                        />
                     </th>
                     <th className={style.thCli}></th>
                     <th className={style.thCli}></th>
                     <th>&nbsp;</th>
                  </tr>
                  <tr  className={style.trTitle}>
                     <th className={style.title}>Nombre</th>
                     <th className={style.title}>&nbsp;Usuario</th>
                     <th className={style.title2}>E-Mail</th>
                     <th>Acciones</th>
                  </tr>
               </thead>
               <tbody>
                  {data.length>0 &&
                     data?.map((usr,i) => {
                        return (
                           <tr key={i} className={parseInt(usr.estadoId)===2 ? style.trdatosRed : style.trdatos}>
                              <td className={style.style_td}>{usr.nombrecompleto}</td>
                              <td className={style.style_td}>&nbsp;{usr.username}</td>
                              <td className={style.style_email}>{usr.email}</td>
                              <td className={style.dLink}>
                                 <Link
                                    to={"/formUsuario"}
                                    state={{
                                       id: usr.id,
                                       companyId:      usr.companyId,
                                       username:       usr.username,
                                       email:          usr.email,
                                       estadoId:       usr.estadoId,
                                       perfilusuarios: usr.perfilusuarios,
                                       id_rank:        usr.id_rank,
                                       nombrecompleto: usr.nombrecompleto,
                                    }}
                                 >
                                    <Pencil/> 
                                 </Link>
                                 &nbsp;&nbsp;
                                 <span
                                    title="Eliminar"
                                    className="lucideIconDel"
                                    onClick={() => handleRemove( usr.id)}
                                 >
                                    <SquareX />  
                                    </span>
                              </td>
                           </tr>
                        );
                     })}
               </tbody>
            </table>
         </div>
      </div>
   );
}
